import { c as _c } from "react/compiler-runtime";
import { FunnelStepPageActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-page-actions';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import { Breadcrumbs as BreadcrumbsDashboard, type BreadcrumbsData } from 'shared/components';
import { ViewportSwitch } from 'shared/components/viewport-switch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface FunnelHeaderProps {
  funnelId: FunnelId;
  selectedFunnelStep: FunnelStepInterface | null;
}
function FunnelHeader(t0) {
  const $ = _c(22);
  const {
    funnelId,
    selectedFunnelStep
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.breadcrumbs.funnel_list");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      caption: t1,
      href: "/funnels",
      isStatic: true
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = funnel?.name ?? "";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      caption: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== selectedFunnelStep) {
    t5 = selectedFunnelStep ? [{
      caption: selectedFunnelStep.name
    }] : [];
    $[6] = selectedFunnelStep;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = [t2, t4, ...t5];
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const breadcrumbsData = t6;
  const selectedPage = selectedFunnelStep?.page;
  const t7 = !funnel;
  let t8;
  if ($[12] !== breadcrumbsData || $[13] !== t7) {
    t8 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t7} />;
    $[12] = breadcrumbsData;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== funnelId || $[16] !== selectedFunnelStep || $[17] !== selectedPage) {
    t9 = selectedFunnelStep && selectedPage && <ViewportSwitch at="desktop" below={null} from={<div className="flex items-center gap-3"><FunnelStepPageActions funnelId={funnelId} funnelStep={selectedFunnelStep} pageId={selectedPage.id} /></div>} />;
    $[15] = funnelId;
    $[16] = selectedFunnelStep;
    $[17] = selectedPage;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex items-center justify-between gap-4 pb-5">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export default FunnelHeader;